import React, { useEffect } from 'react';
import { Form } from 'antd';
import axios from 'axios';
import IconCheckbox from '../../../../components/icon-checkbox';
import { RubleIcon } from '../../../../resource/icons';
import { useSelector } from 'react-redux';
import request from '../../../../helpers/request';
import { useValueRef } from '../../../../hooks/useValueRef';

const selectHouseId = (state) => state.newRequestStore.valueAddrBuilding;
const selectServiceId = (state) => state.newRequestStore.valueSubservice;

const checkChargeable = ({ params, fetchConfig }) =>
  request.get(
    'Request/check_chargeable',
    params,
    undefined,
    undefined,
    undefined,
    fetchConfig
  );

const fieldName = 'isChargeable';

const ChargeableCheckbox = ({ form }) => {
  const { getFieldDecorator, setFieldsValue } = form;

  const houseId = useSelector(selectHouseId);
  const serviceId = useSelector(selectServiceId);

  const valuesRef = useValueRef({ setFieldsValue });

  useEffect(() => {
    if (houseId && serviceId) {
      let ignore = false;
      const source = axios.CancelToken.source();

      checkChargeable({
        params: { serviceId, houseId },
        fetchConfig: { cancelToken: source.token },
      }).then((result) => {
        if (!ignore && result) {
          valuesRef.current.setFieldsValue({
            [fieldName]: result.isChargeable,
          });
        }
      });

      return () => {
        source.cancel();
        ignore = true;
      };
    }
  }, [houseId, serviceId, valuesRef]);

  return (
    <Form.Item>
      {getFieldDecorator(fieldName, { initialValue: false })(
        <IconCheckbox icon={<RubleIcon />}>Платная</IconCheckbox>
      )}
    </Form.Item>
  );
};

export default ChargeableCheckbox;
